import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormItem, FormLabel, FormInputTextarea } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';

var _excluded = ["label", "feedback", "helper", "caption", "tooltip"],
  _excluded2 = ["id", "disabled", "readonly"];
function TextArea(props) {
  var _useField = useField(_objectSpread2({
      type: 'text'
    }, props)),
    informed = _useField.informed,
    fieldState = _useField.fieldState,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var label = userProps.label,
    feedback = userProps.feedback,
    helper = userProps.helper,
    caption = userProps.caption,
    tooltip = userProps.tooltip,
    inputProps = _objectWithoutProperties(userProps, _excluded);
  var id = inputProps.id,
    disabled = inputProps.disabled,
    readonly = inputProps.readonly,
    restInputProps = _objectWithoutProperties(inputProps, _excluded2);
  var showError = fieldState.showError,
    error = fieldState.error;
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    variant: "textarea",
    disabled: disabled,
    readOnly: readonly
  }, label ? /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    caption: caption,
    tooltip: tooltip
  }, label) : null, /*#__PURE__*/React.createElement(FormInputTextarea, _extends({}, informed, restInputProps, {
    id: id,
    inputRef: ref,
    readOnly: readonly,
    disabled: disabled
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError
  })));
}

export { TextArea };
